export const AID_TYPES = {
    ADDITION: 'ADDITION',
    AID: 'AID'
  };
  